module.exports = __webpack_public_path__ + "img/foot_touji.dab2fa78.png";